import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { loadMultipageForm } from "../../Utils/MultiPageForm/loadMultipageForm";
import { infoToast, successToast } from "../../Utils/utils";


export function loadInstanceSetup(){
    
    loadMultipageForm(send)
 
}

function send(data, btn = false){
    const instanceId = $("#instance-id").val()

    infoToast("Deine Nachhilfeschule wird vorbereitet...", "Bitte warte kurz")
   
    const url = '/instance/' + instanceId.toString() + '/setup'

    const success = function (data){
        toastr.remove()
        successToast("Deine Nachhilfeschule ist fertig", "Erfolg")
    }

    return ajaxRequest(url, success, data, btn)
}